import { User } from "../../User";
import {
  AppAssignmentAction,
  AppAssignmentActionType,
  IAppAssignedUsersLoadedPayload,
  ISetAppAssignedUsersErroredPayload
} from "../Actions/AppAssignmentActions";

export interface AppAssignmentState {
  users: User[];
  isLoaded: boolean;
  isLoading: boolean;
  isErrored: boolean;
  errorMessage?: string;
  errorCode?: number;
}

const initialAppAssignmentState: AppAssignmentState = {
  users: [],
  isLoaded: false,
  isLoading: false,
  isErrored: false
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const appAssignmentReducer = (
  appAssignmentState: AppAssignmentState = initialAppAssignmentState,
  action: AppAssignmentAction
) => {
  switch (action.type) {
    case AppAssignmentActionType.APP_ASSIGNED_USERS_LOADED: {
      const payload = <IAppAssignedUsersLoadedPayload>action.payload;
      return updateObject(appAssignmentState, {
        users: payload.loadedUsers,
        isLoaded: true,
        isLoading: false,
        isErrored: false
      });
    }
    case AppAssignmentActionType.APP_ASSIGNED_USERS_UNLOAD: {
      return updateObject(appAssignmentState, {
        users: [],
        isLoaded: false,
        isLoading: false,
        isErrored: false
      });
    }
    case AppAssignmentActionType.APP_ASSIGNED_USERS_LOADING: {
      return updateObject(appAssignmentState, {
        isLoaded: false,
        isLoading: true,
        isErrored: false
      });
    }
    case AppAssignmentActionType.APP_ASSIGNED_USERS_ERRORED: {
      const payload = <ISetAppAssignedUsersErroredPayload>action.payload;
      return updateObject(appAssignmentState, {
        isLoaded: false,
        isLoading: false,
        isErrored: true,
        errorCode: payload.errorCode,
        errorMessage: payload.errorMessage
      });
    }
    default:
      return appAssignmentState;
  }
};

export default appAssignmentReducer;
